import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Select from 'components/UI/Select';
import Input from 'components/UI/Input';
import Modal from 'components/Modal';
import { CLIENT_EXISTS_TYPES } from 'constants/registration';
import EmbedPdf from 'components/EmbedPdf';
import StepHeader from './StepHeader';

const ClientStart = ({
  literals,
  exists,
  onChange,
  onContinue,
  onEvent,
  showNewRegistration = true,
}) => {
  const [showWhereClientNumber, setShowWhereClientNumber] = useState(false);

  const handleChange = (attr, val) => {
    if (attr === 'value') {
      if (exists.type === CLIENT_EXISTS_TYPES.CLIENT_ID) {
        if (val.length > 10) {
          return;
        }
      }
    }
    onChange({ ...exists, [attr]: val });
  };

  const handleBlurIdentifier = () => {
    if (exists.type === CLIENT_EXISTS_TYPES.CLIENT_ID) {
      const identifier = (exists.value || '').trim();
      if (identifier && identifier.length < 10) {
        handleChange('value', identifier.padStart(10, '0'));
      }
    }
  };

  return (
    <div className='full-screen-container'>
      <div className='screen-content'>
        <StepHeader step={1} onEvent={onEvent} />
        <p className='font-bold text-primary mb-4 text-xl'>{literals.start.areYouAClient}</p>
        <p className='font-black mb-6'>{literals.start.ifYouAlreadyAreAClient}</p>
        <Select
          value={exists.type}
          onChange={(v) => handleChange('type', v)}
          className='mb-6'
          canBeEmpty={false}
          options={[
            { label: literals.common.clientNumber, value: CLIENT_EXISTS_TYPES.CLIENT_ID },
            { label: literals.common.ine, value: CLIENT_EXISTS_TYPES.INE },
          ]}
        />
        <Input
          type={exists.type === CLIENT_EXISTS_TYPES.INE ? 'text' : 'number'}
          value={exists.value}
          onChange={(v) => handleChange('value', v)}
          onBlur={handleBlurIdentifier}
          placeholder={exists.type === CLIENT_EXISTS_TYPES.INE ? '000000000' : literals.start.tenDigits}
          className='mb-2'
        />
        {exists.type === CLIENT_EXISTS_TYPES.CLIENT_ID && (
          <p className='text-sm underline mb-6 text-right' onClick={() => setShowWhereClientNumber(true)}>{literals.start.whereClientNumber}</p>
        )}
      </div>
      <div className='screen-actions'>
        <Button disabled={!exists.value || !exists.type} onClick={() => onContinue(true)}>{literals.common.continue}</Button>
        {showNewRegistration && (
          <div>
            <hr />
            <p className='text-center'>{literals.start.ifYouAreNotAClient}</p>
            <Button type='outline-primary' onClick={() => onContinue(false)}>{literals.start.makeYourRegistration}</Button>
          </div>
        )}
      </div>
      {showWhereClientNumber && (
        <Modal
          position='end'
          onClose={() => setShowWhereClientNumber(false)}
        >
          <EmbedPdf
            src={`${document.location.origin}/files/client-number.pdf`}
            downloadable
            height='50'
          />
          <Button type='primary' className='mt-6' onClick={() => setShowWhereClientNumber(false)}>{literals.common.close}</Button>
        </Modal>
      )}
    </div>
  );
};

ClientStart.propTypes = {
  literals: PropTypes.object.isRequired,
  exists: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onEvent: PropTypes.func.isRequired,
  showNewRegistration: PropTypes.bool,
};

export default ClientStart;
